<div class="seccion4">

  <div class="news-recommend">
    <div class="carruselcontent2">
      <div class="contentcarruselbox">
        <div class="contenedor-principal">

          <div class="control-carrusel-publicidad">
            <div class="carrusel">
              <div class="imagen" *ngFor="let publicit of publicidad">
                <a>
                  <div class="contenttextimg" (click)="analyticsEvnt()">
                    <img [src]="publicit">
                    <div class="contenttxtcarruselfoto">
                      <div class="imgtextcarrusel">

                      </div>

                    </div>
                  </div>
                </a>
              </div>


            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
